import axios from '@/server/axios'


export function queryLocation() {
  return axios({
    url: 'officialWebsite/queryGeographic.do',
    method: 'get',
    params: {

    }
  })
}